<template>
    <FormInput :context="context">
        <component v-if="componentExists" :is="componentName" :context="context" :meta="meta" />
        <PrimeVueMessage v-else severity="error">
            {{ errorMessage }}
        </PrimeVueMessage>
    </FormInput>
</template>

<script>
import FormInputMixin from "@/components/forms/inputs/mixins/FormInputMixin";
import PrimeVueMessage from "primevue/message";

export default {
    mixins: [ FormInputMixin ],
    components: { PrimeVueMessage },
    props: ["context", "meta", "componentName"],
    data() {
        return {
            errorMessage: `Could not find custom component: "${this.componentName}".`
        }
    },
    computed: {
        loadedComponents() {
            var loaded = [];
            var components = this.$options.components;
            for (var key in components) {
                loaded.push(key);
            }
            return loaded;
        },
        componentExists() {
            return this.loadedComponents.includes(this.componentName);
        },
    }
};
</script>
